"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var WechatModule = /** @class */ (function (_super) {
    __extends(WechatModule, _super);
    function WechatModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询二维渠道列表
     * @param page 页数
     * @param pageSize 每页记录数
     * @param sourcesName 渠道名
     * @param token 用户唯一标识
     */
    WechatModule.prototype.getSources = function (params, token) {
        return this.gatewayClient.getSources(params, token);
    };
    /**
     * 查询二维码列表
     * @param page 页数
     * @param pageSize 每页记录数
     * @param city 城市
     * @param province 省
     * @param cmsName 推广人员
     * @param sources 渠道名
     * @param token 用户唯一标识
     */
    WechatModule.prototype.queryQrcodeList = function (params, token) {
        return this.gatewayClient.queryQrcodeList(params, token);
    };
    /**
     * 新增二维码
     * @param city 城市
     * @param cityId 城市id
     * @param cmsName 推广人员
     * @param keyword 关键词
     * @param name 二维码名称
     * @param province 省份
     * @param provinceId 省份id
     * @param sources 二维码渠道
     * @param state 二维码状态 1：可用 2：不可用
     * @param token 用户唯一标识
     */
    WechatModule.prototype.addQrcodeCreate = function (city, cityId, cmsName, keyword, name, province, provinceId, sources, state, token) {
        return this.gatewayClient.addQrcodeCreate(city, cityId, cmsName, keyword, name, province, provinceId, sources, state, token);
    };
    /**
     * 编辑二维码
     * @param city 城市
     * @param cityId 城市id
     * @param cmsName 推广人员
     * @param keyword 关键词
     * @param name 二维码名称
     * @param province 省份
     * @param provinceId 省份id,
     * @param qrId 二维码Id
     * @param state 二维码状态 1：可用 2：不可用
     * @param token 用户唯一标识
     */
    WechatModule.prototype.editQrcodeEdit = function (city, cityId, cmsName, keyword, name, province, provinceId, qrId, state, sources, token) {
        return this.gatewayClient.editQrcodeEdit(city, cityId, cmsName, keyword, name, province, provinceId, qrId, state, sources, token);
    };
    /**
     *
     * @param qrId 二维码id
     * @param token
     */
    WechatModule.prototype.deleteQrcodeDelete = function (qrId, token) {
        return this.gatewayClient.deleteQrcodeDelete(qrId, token);
    };
    /**
     * 添加/编辑 渠道
     * @param remark 备注
     * @param sources 渠道名
     * @param sourcesRate 费率
     * @param token
     */
    WechatModule.prototype.updateSources = function (params, token) {
        return this.gatewayClient.updateSources(params, token);
    };
    /**
     * 删除渠道
     * @param qrId 二维码id
     * @param token
     */
    WechatModule.prototype.deleteSources = function (scId, token) {
        return this.gatewayClient.deleteSources(scId, token);
    };
    return WechatModule;
}(gateway_module_1.GatewayModule));
exports.WechatModule = WechatModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/wechat/index.js
// module id = 221
// module chunks = 44